import React, { lazy } from "react";
import { Helmet } from "react-helmet-async";
import StreetTodayHero from "@/components/StreetTodayHero";
import LatestOnStreet from "@/components/LatestOnStreet";
import LazySection from "@/components/LazySection";

const MarketMomentum = lazy(() => import("@/components/MarketMomentum"));
const SectorHeatmap = lazy(() => import("@/components/SectorHeatmap"));
const StockChart = lazy(() => import("@/components/StockChart"));
const IPOStreetTable = lazy(() => import("@/components/IPOStreetTable"));
const InsideFilingCard = lazy(() => import("@/components/InsideFilingCard"));
const DeepDives = lazy(() => import("@/components/DeepDives"));

export default function Home() {
  return (
    <div className="px-4 sm:px-6 lg:px-10 py-6 lg:py-8 max-w-[1400px] mx-auto space-y-6 lg:space-y-8">
      <Helmet>
        <title>Nivesh Street: Live Indian Market Intelligence · NSE, BSE, IPO, DRHP</title>
        <meta name="description" content="Real-time NSE/BSE prices, IPO & DRHP analysis, market news, commodities, crypto, real estate and market mood — editorial-grade Indian market intelligence." />
        <meta property="og:title" content="Nivesh Street: Live Indian Market Intelligence" />
        <meta property="og:description" content="Real-time NSE/BSE prices, IPO & DRHP analysis, commodities, crypto & market mood." />
        <meta property="og:url" content="https://niveshstreet.in/" />
        <meta property="og:image" content="https://niveshstreet.in/og-social-card.jpg" />
        <meta property="og:image:secure_url" content="https://niveshstreet.in/og-social-card.jpg" />
        <meta property="og:image:type" content="image/jpeg" />
        <link rel="canonical" href="https://niveshstreet.in/" />
      </Helmet>

      {/* Row 1 — Hero (2/3) + Latest + Momentum/Heatmap/Chart (1/3) */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 flex flex-col gap-6">
          <StreetTodayHero />
          <LatestOnStreet />
        </div>
        <div className="flex flex-col gap-6">
          <LazySection minHeight={420}>
            <div className="flex flex-col gap-6">
              <MarketMomentum />
              <SectorHeatmap />
              <StockChart />
            </div>
          </LazySection>
        </div>
      </div>

      {/* Row 2 — IPO Street + Inside the Filing */}
      <LazySection minHeight={360}>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <IPOStreetTable />
          </div>
          <InsideFilingCard />
        </div>
      </LazySection>

      {/* Row 3 — Deep Dives */}
      <LazySection minHeight={320}>
        <DeepDives />
      </LazySection>
    </div>
  );
}
